import { initializeSentry } from './utils/sentryConfig';

// Initialize Sentry before loading the rest of the app modules.
// initializeSentry() self-guards on `sentryEnabled` (local-like env + DSN check).
initializeSentry();


